export default (timeFormat, date) => {
  const onlyInitialH = timeFormat.substring(1);
  return onlyInitialH;
};
